<template>
  <div class="card h-100">
    <div class="card-body">
      <p>
        <small class="font-weight-bold">Total Submitter</small>
      </p>
      <highcharts :options="chartOptions" />
      <div class="achieved-card mt-3">
        <div class="d-flex align-items-center">
          <div class="achieved-icon">
            <i class="fa fa-star text-info" />
          </div>
          <small class="font-weight-bold ml-3">Achieved</small>
        </div>
        <small class="font-weight-bold">{{ percentage }}%</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fit: {
      type: Number,
      required: true
    },
    totalResponded: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    chartOptions: {
      title: false,
      credits: false,
      chart: {
        type: 'gauge',
        height: 210,
        spacing: [0, 0, 0, 0]
      },
      pane: {
        startAngle: -90,
        endAngle: 90,
        center: ['50%', '75%'],
        size: '110%',
        background: null
      },
      yAxis: {
        min: 0,
        max: 0,
        lineWidth: 0,
        tickLength: 0,
        minorTickLength: 0,
        tickPositions: [],
        labels: {
          distance: 18,
          style: {
            color: '#9CA3AF',
            fontSize: '12px'
          }
        },
        plotBands: []
      },
      tooltip: {
        enabled: false
      },
      series: [{
        name: 'Total Submitter',
        data: [{ y: 0, total: 0 }],
        dial: {
          radius: '85%',
          backgroundColor: '#111827',
          baseWidth: 6,
          topWidth: 1,
          baseLength: '0%',
          rearLength: '0%'
        },
        pivot: {
          radius: 5,
          backgroundColor: '#111827'
        },
        dataLabels: {
          useHTML: true,
          borderWidth: 0,
          y: 35,
          format:
            '<div style="text-align:center;font-weight:700;font-size:16px;color:#111827">{y:.0f}/{point.total}</div>'
        }
      }]
    }
  }),

  computed: {
    percentage () {
      const total = Number(this.totalResponded) || 0
      const value = Number(this.fit) || 0
      if (total === 0) return 0
      return Math.round((value / total) * 100)
    }
  },

  watch: {
    fit: {
      immediate: true,
      handler () {
        this.apply()
      }
    },
    totalResponded: {
      immediate: true,
      handler () {
        this.apply()
      }
    }
  },

  methods: {
    apply () {
      const total = Number(this.totalResponded) || 0
      const value = Number(this.fit) || 0

      this.chartOptions.yAxis.max = total
      this.chartOptions.yAxis.tickPositions = [0, total]

      const redEnd = Math.round(total * 0.28)
      const orangeEnd = Math.round(total * 0.68)
      this.chartOptions.yAxis.plotBands = [
        { from: 0, to: redEnd, color: '#EF4444', thickness: 18 },
        { from: redEnd, to: orangeEnd, color: '#F59E0B', thickness: 18 },
        { from: orangeEnd, to: total, color: '#18B2BD', thickness: 18 }
      ]

      this.chartOptions.series[0].data[0].y = value
      this.chartOptions.series[0].data[0].total = total
    }
  }
}
</script>

<style scoped>
.achieved-card {
  align-items: center;
  border: 1px solid #dedede;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 14px 16px;
}

.achieved-icon {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #dedede;
  border-radius: 10px;
  display: flex;
  height: 36px;
  justify-content: center;
  width: 36px;
}
</style>
